module.exports = __webpack_public_path__ + "static/media/insert-icon.c2039957.svg";